import { injectCpmsBoTransactionReportsCountStatisticsApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-transaction-reports-count-statistics.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoTransactionReportsCountStatisticsApi =
  injectCpmsBoTransactionReportsCountStatisticsApi(baseApi);

export const {
  useCpmsBoGetTransactionReportsCountByLocationQuery,
  useCpmsBoGetTransactionReportsCountByThirdPartyEndpointQuery,
  useCpmsBoGetTransactionReportsCountByChargePointQuery,
  useCpmsBoGetTransactionReportsCountByConnectorTypeQuery,
  useCpmsBoGetTransactionReportsCountByTokenTypeQuery,
  useCpmsBoGetTransactionReportsCountByDayQuery,
  useCpmsBoGetTransactionReportsCountByMonthQuery,
  useCpmsBoGetTransactionReportsCountByYearQuery,
  useCpmsBoGetTransactionReportsCountForecastQuery,
  useCpmsBoGetTransactionReportsCountQuery,
} = cpmsBoTransactionReportsCountStatisticsApi;
